import styled from '@emotion/styled';

import Button from 'components/field/Button';
import FormItem from 'components/form/FormItem';

import { Breakpoints } from 'utils/const.styles';

export const TemplateContainer = styled.div`
	width: 100%;
	display: flex;
	@media ${Breakpoints.tablet} {
		flex-direction: column-reverse;
	}
	@media (hover: none) {
		flex-direction: column-reverse;
	}
`;

export const PdfContainer = styled.div`
	display: flex;
	margin-right: var(--margin-2);
	width: 80%;
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-2);
	}
	@media ${Breakpoints.tablet} {
		width: 100%;
	}
`;

export const ConfigContainer = styled.div`
	width: 20%;
	display: flex;
	flex-direction: column;
	padding: 0 var(--padding-2);
	padding-bottom: 4rem;
	border-left: 1px solid var(--border-color);
	max-height: inherit;
	height: 80dvh;
	overflow-x: hidden;
	overflow-y: scroll;
	@media ${Breakpoints.tablet} {
		width: 100%;
		height: unset;
		justify-content: flex-start;
		align-items: center;
		padding: 0;
		border: none;
	}
	@media (hover: none) {
		width: 100%;
	}
`;

export const ColumnSelectorButton = styled(Button)`
	&.borderless {
		width: 100%;
		background: var(--input-bg-color);
		padding: var(--inputPadding);
		border: 1px solid var(--border-color);
		border-radius: var(--small-border-radius);
		justify-content: start;
		align-items: center;
		span {
			font-weight: 500;
			color: var(--black);
		}
		.icon {
			font-size: var(--paragraph3-font-size) !important;
		}
	}
`;

export const ConfigEnums = styled.div`
	@media ${Breakpoints.tablet} {
		display: flex;
		width: 100%;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	@media (hover: none) {
		width: 100%;
	}
`;

export const ConfigOptions = styled.div`
	@media ${Breakpoints.tablet} {
		display: flex;
		width: 100%;
		flex-direction: row;
		flex-wrap: wrap;
		margin-left: var(--margin-2);
	}
`;

export const ConfigurationOptionList = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const FormItemSwitch = styled(FormItem)`
	@media (hover: none) {
		flex: 0 0 25%;
	}
	@media ${Breakpoints.tablet} {
		flex: 0 0 25%;
	}
	@media ${Breakpoints.mobile} {
		flex: 0 0 50%;
	}
`;

export const AccordionInner = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const ButtonSection = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	& > button {
		&:first-of-type {
			margin-right: var(--margin-2);
		}
	}
	body[dir='rtl'] & > button {
		&:first-of-type {
			margin-left: var(--margin-2);
		}
	}
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: stretch;
		justify-content: flex-start;

		& > button {
			width: 100%;
			&:first-of-type {
				margin-right: 0;
				margin-bottom: var(--margin-2);
			}
		}
	}
`;

export const TemplateCardContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	overflow: hidden;
	padding: var(--padding-2);
`;

export const TemplateCardItem = styled(FormItem)`
	flex: 0 0 25%;
	padding: 0;
	@media ${Breakpoints.tablet} {
		padding: 0;
		flex: 0 0 33.333%;
	}
	@media ${Breakpoints.mobile} {
		flex: 0 0 50%;
	}
`;

export const TemplateArea = styled.div``;

export const AdvancedSettingsButton = styled(Button)`
	justify-content: space-between;

	> .icon > svg {
		transition: all 0.3s ease-in-out;
	}
`;
